
$(function() {
	checkDateInputs();

    $('[data-background], img[data-src]').imageLoader();

    // Open popup links inside a modal
    $(document).on('click', 'a.popup', function (e) {
        e.preventDefault();
        window.top.openIframePopup($(this).attr('href'));
	});

    // Make sure internal links inside popups are opened correctly
    $('body.popup .text a[href^="/"]').addClass('popup');

    // Make sure external links inside popups are opened in a new window
    $('body.popup a[href^="http"]').attr('target', '_blank');

	$('.toggle-text-size').on('click', function(e) {
		e.preventDefault();

		var $html = $('html');
		var size  = $html.attr('data-text-size');

		// if (size === 'md') size = 'lg';
		// else if (size === 'lg') size = 'sm';
		// else size = 'md';

		if (size === 'lg') size = 'sm';
		else size = 'lg';

		$.get('/site/ajax/set_text_size.php?size=' +  size);
		$html.attr('data-text-size', size);
	});

	const tooltipSelector = '[data-bs-toggle="tooltip"]';
	$('body').tooltip({
		selector: tooltipSelector,
		delay: 400,
	}).on('click', () => {
		$(tooltipSelector).tooltip('hide');
	});

	$('.navbar a').on('click', function(e) {
		var $dropdownToggler = $(e.target).closest('.dropdown-toggler');

		if ($dropdownToggler.length > 0) {
			e.preventDefault();
		}
	});

	$('.speak').on('click', function(e) {
		e.preventDefault();

		const $readStop  = $('.speak').find('.read-stop');
		const $readStart = $('.speak').find('.read-start');

		if ($readStop.hasClass('d-none')) {
			$readStop.removeClass('d-none');
			$readStart.addClass('d-none');
			$('.rsbtn_text').trigger("click");

		} else {
			$readStop.addClass('d-none');
			$readStart.removeClass('d-none');
			$('.rsbtn_stop').trigger("click");
		}
	});

    $(document).on('click', '.confirm', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showConfirm({
            text: $(this).data('confirm'),
            textYes: $(this).data('text-yes'),
            textNo: $(this).data('text-no'),
            urlYes: $(this).attr('href'),
            onConfirm: $(this).data('onconfirm'),
        });
    });

    $(document).on('click', '.show-alert', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showAlert({
            text: $(this).data('alert'),
            textHeader: $(this).data('header'),
            textButton: $(this).data('btn-text'),
        });
    });

    $('input[type=number]').on('input', function () {
        var min = parseInt($(this).attr('min'));
        var max = parseInt($(this).attr('max'));
        var maxLength = parseInt($(this).attr('maxlength'));
        var value = parseInt($(this).val());

        if (!isNaN(max) && value > max) {
            $(this).val(max);
        }

        if (!isNaN(min) && value < min) {
            $(this).val(min);
        }

        if (!isNaN(maxLength)) {
            $(this).val($(this).val().substring(0, maxLength));
        }
    });

	$('select').on('change empty-init', function() {
		$(this).toggleClass('empty', $(this).val() === '');
	}).trigger('empty-init');

    $(document).on('click', '.btn', function (e) {
        var $btn = $(this);
        $btn.addClass('clicked');

        setTimeout(function () {
            $btn.removeClass('clicked');
        }, 100);
    });

});

setInterval(function() {
    $.get('/lib/keepalive.php');
}, 1000 * 60 * 10);

